import { AiOutlineHome } from "react-icons/ai";
import { NavLink, Outlet } from "react-router-dom";
import getPermissions from "../../utils/getPermissions";
import { sections } from "./setupSections";

const navItemClass = ({ isActive }) =>
  `flex shrink-0 items-center gap-2 rounded-xl px-4 py-2 text-sm font-semibold whitespace-nowrap transition-all ${
    isActive
      ? "bg-white text-[#023f88] shadow-md"
      : "text-blue-50/90 hover:bg-white/15 hover:text-white"
  }`;

export default function SetupLayout() {
  const permissions = getPermissions() || [];
  const navItems = sections.filter((s) => permissions.includes(s.permission));

  return (
    <div
      className='px-4 overflow-y-auto overflow-x-hidden'
      style={{ height: "calc(100vh - 102px)" }}
    >
      {/* Setup navigation (replaces the old left sidebar) */}
      <div className='max-w-7xl mx-auto pt-5'>
        <nav className='flex gap-1.5 overflow-x-auto rounded-2xl bg-gradient-to-r from-[#011f44] via-[#023f88] to-[#0b5cae] p-1.5 shadow-lg'>
          <NavLink to='/admin/setup' end className={navItemClass}>
            <AiOutlineHome className='text-base' />
            Setup Home
          </NavLink>
          {navItems.map(({ title, to, icon: Icon }) => (
            <NavLink key={to} to={to} className={navItemClass}>
              <Icon className='text-base' />
              {title}
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
